import React, { Component } from "react";
import { ConstantBasedPicker } from "@openimis/fe-core";

import { SCHEMES } from "../constants";

class SchemesPicker extends Component {

    render() {
        const { readOnly = false, required = false, withNull = true, nullLabel = null } = this.props;
        
        return <ConstantBasedPicker
            module="scheme"
            label="Schemes"
            constants={SCHEMES}
            readOnly={readOnly}
            {...this.props}
        />
    }
}

export default SchemesPicker;